import { Paper } from '@mui/material';
import { ArticleOutlined, HomeOutlined, LocalMallOutlined, PersonOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from './functions/utils';

import React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import Home from './pages/Home';
import Cardapio from './pages/Cardapio';
import Pedidos from './pages/Pedidos';
import Perfil from './pages/Perfil';
import axios from 'axios';
import Suspenso from './pages/Suspenso';

const AppHome = () => {

  const [colorPrimary, setColorPrimary] = useState('');
  const [colorSecondary, setColorSecondary] = useState('');
  const [colorTertiary, setColorTertiary] = useState('');
  const [value, setValue] = useState('');
  const [tipoLoja, setTipoLoja] = useState("restaurante");
  const [onlyMenu, setOnlyMenu] = useState(false);
  const [isMesa, setIsMesa] = useState(false);
  const [enableStore, setEnableStore] = useState("");
  const [usuarioSuspenso, setUsuarioSuspenso] = useState("");

  const state = useLocation().state;

  const handleConfigs = (isMesa, onlyMenu, tipoLoja, isEnabled, enable) => {
    if (isMesa) {
      setValue("cardapio");
      setIsMesa(isMesa);
    }
    if (onlyMenu) {
      setValue("cardapio");
      setOnlyMenu(true)
    }
    if (tipoLoja) {
      setTipoLoja(tipoLoja)
    }
    if (isEnabled === "ENABLED") {
      setEnableStore(enable)
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (state !== null) {
      if (state.page !== null) {
        setValue(state.page)
        state.page = null
      }
    }

    const onlyMenu = localStorage.getItem('eNbM') === "true";
    if (onlyMenu) {
      setOnlyMenu(onlyMenu)
    }

    const enableStore = localStorage.getItem('eNbS') === "true";
    setEnableStore(enableStore)
    const colorPrimaryC = localStorage.getItem('clPmr');
    if (!colorPrimaryC) {
      getColors()
      return
    }

    let url = localStorage.getItem('UBs');
    if (!url) {
      url = window.location.href;
      if (url.includes("localhost")) {
        url = "https://confeitariadanath.gustio.com.br/";
      }
    }
    const urlBase = new URL(url).origin;
    getActiveMenu(urlBase);
    const colorSecondaryC = localStorage.getItem('clScr');
    const colorTertiaryC = localStorage.getItem('clTcr');

    setColorPrimary(colorPrimaryC)
    setColorSecondary(colorSecondaryC)
    setColorTertiary(colorTertiaryC)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getColors = async () => {

    let urlBase = window.location.origin;

    if (window.location.hostname === "localhost") {
      urlBase = "https://confeitariadanath.gustio.com.br";
    }

    const defaultPrimary = '194, 41, 0';
    const defaultSecondary = '96, 32, 32';
    const defaultTertiary = '204, 122, 0';

    try {
      const resp = await axios.post(
        `https://gerenciador.gustio.com.br/api/cores-cliente.php`,
        {
          urlBase: urlBase,
        }
      );

      const response = resp.data;

      if (response && response.length > 0) {
        const primary = response[0].cor_primaria || defaultPrimary;
        const secondary = response[0].cor_secundaria || defaultSecondary;
        const tertiary = response[0].cor_terciaria || defaultTertiary;

        localStorage.setItem('clPmr', primary);
        localStorage.setItem('clScr', secondary);
        localStorage.setItem('clTcr', tertiary);

        setColorPrimary(primary);
        setColorSecondary(secondary);
        setColorTertiary(tertiary);
      } else {
        localStorage.setItem('clPmr', defaultPrimary);
        localStorage.setItem('clScr', defaultSecondary);
        localStorage.setItem('clTcr', defaultTertiary);

        setColorPrimary(defaultPrimary);
        setColorSecondary(defaultSecondary);
        setColorTertiary(defaultTertiary);
      }

      getActiveMenu(urlBase);

    } catch (error) {
      console.log(
        "Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. Código (0507)",
        error
      );

      localStorage.setItem('clPmr', defaultPrimary);
      localStorage.setItem('clScr', defaultSecondary);
      localStorage.setItem('clTcr', defaultTertiary);

      setColorPrimary(defaultPrimary);
      setColorSecondary(defaultSecondary);
      setColorTertiary(defaultTertiary);

      getActiveMenu(urlBase);
    }
  };

  //TODO VERIFICAR FUNÇÃO
  const getActiveMenu = (urlBase) => {
    console.log("Verificando se o usuário está suspenso...")
    axios.post(`https://gerenciador.gustio.com.br/api/ativo.php`, {
      url: urlBase.replaceAll("/api", ""),
    })
      .then(response => {
        response = response.data
        if (response) {
          localStorage.setItem('iRc', response[0].id_recebedor);
          response[0].habilita_beta === "A" ? localStorage.setItem('BTMd', "A") : localStorage.setItem('BTMd', "D");

          if (response[0].fechar_estabelecimento === "1") {
            localStorage.setItem("FxEst", "1");
          } else {
            localStorage.removeItem("FxEst")
          }

          if (!response[0].status_pagamento) {
            setUsuarioSuspenso(false);
            return;
          }
          const timestamp = response[0].status_pagamento;
          if (!isNaN(timestamp) && Number.isInteger(Number(timestamp)) && Number(timestamp) > 0) {
            const dataTimestamp = new Date(Number(timestamp) * 1000);
            const agora = new Date();
            const timestampAgora = Date.now() / 1000;

            const diasPassados = (agora - dataTimestamp) / (1000 * 60 * 60 * 24);

            if (response[0].data_expiracao) {
              const expiracao = Number(response[0].data_expiracao) + 604800;

              if (timestampAgora >= expiracao) {
                setUsuarioSuspenso(true);
                setValue("suspenso");
              } else {
                setUsuarioSuspenso(false);
              }
            } else {
              if (diasPassados > 37) {
                console.log("Usuário suspenso por inatividade.");
                setUsuarioSuspenso(true);
                setValue("suspenso");
              } else {
                setUsuarioSuspenso(false);
              }
            }
          } else {
            setUsuarioSuspenso(true);
            setValue("suspenso");
          }
        }
      })
  }

  const handleGetTipoLoja = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <>Cardápio</>
      case "loja":
        return <>Catálogo</>
      default:
        return <>Cardápio</>;
    }
  };

  const handleTipoLojaIcon = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <RestaurantMenuIcon style={{ marginBottom: "6px" }} />
      case "loja":
        return <LocalMallOutlined style={{ marginBottom: "6px" }} />
      default:
        return <RestaurantMenuIcon style={{ marginBottom: "6px" }} />;
    }
  };

  const renderContent = () => {
    switch (value) {
      case 'home':
        return <Home onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'cardapio':
        return <Cardapio onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'pedidos':
        return <Pedidos onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'perfil':
        return <Perfil onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'suspenso':
        return <Suspenso onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      default:
        setValue("home")
        return <Home />;
    }
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <div>
        {/* Renderiza o conteúdo da tela selecionada */}
        {renderContent()}

        {/* Bottom Navigation */}
        {!usuarioSuspenso && enableStore && !onlyMenu && (
          <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
            <BottomNavigation value={value} onChange={handleChange} showLabels={true} style={{ backgroundColor: `rgba(${colorPrimary})`, height: "75px" }} >
              {!isMesa && (
                <BottomNavigationAction label="Home" value="home" icon={<HomeOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "home" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "home" ? "solid #FFF 2px" : "none",
                }} />
              )}
              <BottomNavigationAction label={handleGetTipoLoja()} value="cardapio" icon={handleTipoLojaIcon()} style={{
                fontSize: "12px", fontWeight: "bold",
                color: value === "cardapio" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "cardapio" ? "solid #FFF 2px" : "none",
              }} />
              {!onlyMenu && (
                <BottomNavigationAction label="Pedidos" value="pedidos" icon={<ArticleOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "pedidos" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "pedidos" ? "solid #FFF 2px" : "none",
                }} />
              )}
              {!onlyMenu && !isMesa && (
                <BottomNavigationAction label="Perfil" value="perfil" icon={<PersonOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "perfil" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "perfil" ? "solid #FFF 2px" : "none",
                }} />
              )}
            </BottomNavigation>
          </Paper>
        )}
      </div>
    </ThemeProvider>
  );
};

export default AppHome;
